import { render, staticRenderFns } from "./AliPlayer.vue?vue&type=template&id=3852a1cf&scoped=true"
import script from "./AliPlayer.vue?vue&type=script&lang=js"
export * from "./AliPlayer.vue?vue&type=script&lang=js"
import style0 from "./AliPlayer.vue?vue&type=style&index=0&id=3852a1cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3852a1cf",
  null
  
)

export default component.exports